var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28","width":"28","height":"28","fill":"currentColor"}},[_c('path',{attrs:{"d":"M19 5h5v1h-4v13h-6v-7h-4v12H5v-1h4V11h6v7h4V5Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }